// React
import { createContext } from "react"

// Types
import type { LinkAccountType } from "../../types"

export const ItemContext = createContext<LinkAccountType>({
  dashboard_link_code: "",
  dashboard_link_id: 0,
  dashboard_link_name: "",
  datacoa: [],
  description: ""
})